// extracted by mini-css-extract-plugin
module.exports = {"Container":"bid_Container__sLi5G","MapContainer":"bid_MapContainer__F9Dr_","resultMap":"bid_resultMap__qfKhh","MenuButton":"bid_MenuButton__2reaH"};